import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const clientCreateSchema = yup.object().shape({
  name: yup.string().required(),
  STI_active: yup.boolean(),
  STI_builder_id: yup.mixed().nullable(true).when('STI_active', {
    is: true,
    then: yup.number().required(),
  }),
  LASSO_active: yup.boolean(),
  LASSO_apikey: yup.mixed().nullable().when('LASSO_active', {
    is: true,
    then: yup.string().required(),
  }),
  LASSO_id: yup.mixed().nullable().when('LASSO_active', {
    is: true,
    then: yup.string().required(),
  }),
  academy_active: yup.boolean(),
  bossApi_active: yup.boolean(),
  allDayAccess_active: yup.boolean(),
  adjustableTourHours: yup.boolean(),
  Novihome_active: yup.boolean(),
  active: yup.boolean(),
  is_rental: yup.boolean(),
  is_webflow_code_only: yup.boolean(),
  high_security_verification_active: yup.boolean(),
  lock_lease_fee: yup.number(),
  quickbooks_id: yup.string().transform((value) => (value === "" ? null : value))
    .nullable()
    .matches(/^\d+$/, "quickbooks_id must be a number"),
  quickbooks_billing_rate_detail: yup.number(),
  builder_timezone: yup.number().oneOf([51, 52, 53, 54, 171]).required(),
  quickbooks_billing_rate: yup
    .number()
    .typeError('Quickbooks Billing Rate must be a number')
    .notOneOf([0], 'Quickbooks Billing Rate is required and not equal 0')
    .required(),
  custom_billing: yup.boolean(),
});
